'use client';

import { Toaster } from 'react-hot-toast';

export const ToasterProvider = () => <Toaster position="top-right" />;
